import React from 'react';
import FaFileUpload from '../FactureeComponents/FaFileUpload';
import {Box, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import ShowCode from "../helpers/ShowCode.js";
const FactureeCompUploadExmpl = () => {
  
  const example1 = `<>
  <FaFileUpload
    uploadCallback={(files) => {
      console.log(files[0]);
      return true;
    }}
    displayFileRules={true}
  />
</>`;
  return (
    <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>
      <Typography variant={"h3"} sx={{marginBottom: '2rem'}}>FaFileUpload Component</Typography>
      <FaFileUpload
          uploadCallback={(files:any) => {console.log(files[0]); return true;}}
          displayFileRules={true}
      />
      <ShowCode codeString={example1} scope={{ React, FaFileUpload }} />
      <Divider sx={{ marginTop: '2rem' }} />

      <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
      <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
        Complete list of all props supported by the FaFileUpload component.
      </Typography>

      <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
        <Table>
          <TableHead>
            <TableRow sx={{backgroundColor: 'primary.main'}}>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><code>uploadCallback</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>(file: File[]) =&gt; void</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Callback function triggered when files are uploaded; receives an array of File objects.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>id</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the component container.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>placeholder</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"Drag & Drop or"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Placeholder text displayed in the upload area; supports HTML.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>buttonText</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"Choose Files"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Text displayed on the upload button.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>buttonVariant</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'text' | 'outlined' | 'contained'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"outlined"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Visual variant of the upload button.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>ErrorMsgs</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>{'{'}exceedFileNum?: string, exceedFileSize?: string, customErr1?: string, customErr2?: string, customErr3?: string{'}'}</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Custom error messages for various validation scenarios.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>sx</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling of the upload area.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>icon</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>&lt;CloudUploadIcon /&gt;</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Custom icon to display in the upload area.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>accept</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>Default file types</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Object defining accepted file types and extensions (e.g., {'{'}'image/*': ['.jpg', '.png']{'}'}).</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>maxFiles</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>number</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>1</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Maximum number of files that can be uploaded at once.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>maxFileSize</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>number</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>5120000</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Maximum file size in bytes (default is 5MB).</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>displayFileRules</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>boolean</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>When true, displays the list of accepted file extensions in the upload area.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>disabled</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>boolean</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>When true, disables the upload functionality.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
        * Required prop
      </Typography>
    </Box>
  )
};
export default FactureeCompUploadExmpl;
